export enum CommentTypeEnum {
  REVIEW = 1,
  QUESTION = 2,
  REPLY = 3,
}
export enum ReactionType {
  LIKE = 1,
  DISLIKE = 2,
}
